import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { HtmlInputEvent } from '../utils/types/HtmlnputEvent';

export interface OptionProps<ValueType extends string> {
    value: ValueType | '';
    label: string;
    id?: string;
}

interface SelectProps<ValueType extends string> {
    id: string;
    label: string;
    name: string;
    options: OptionProps<ValueType>[];
    value?: string;
    required?: boolean;
    testId?: string;
    className?: string;
    onChange: (value: ValueType) => void;
}

function Select<ValueType extends string>(
    props: SelectProps<ValueType>
): ReactElement {
    const { t } = useTranslation();
    const {
        id,
        label,
        name,
        options,
        value = '' as ValueType,
        required = false,
        testId,
        onChange,
        className,
    } = props;
    return (
        <div className="form-group">
            <label htmlFor={id}>{label}</label>
            <select
                className={`form-control ${className ?? ''}`}
                id={id}
                data-testid={testId}
                name={name}
                value={value}
                required={required}
                onChange={(e: HtmlInputEvent) => {
                    onChange(e.target.value as ValueType);
                }}
            >
                <option disabled value="" data-testid="default-value-select">
                    {t('Select option')}
                </option>
                {options.map((option) => (
                    <option
                        key={option.value}
                        value={option.value}
                        id={option.id}
                    >
                        {option.label}
                    </option>
                ))}
            </select>
        </div>
    );
}

export default Select;
